import moment from 'moment'

export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export function getWeekStart(today: moment.Moment, offset: number) {
  return today.clone().startOf('week').add(offset, 'weeks')
}

export function getWeekDays(weekStart: moment.Moment): moment.Moment[] {
  return Array.from({ length: 7 }, (_, i) => weekStart.clone().add(i, 'days'))
}

export function formatWeekRange(weekStart: moment.Moment): string {
  const weekEnd = weekStart.clone().add(6, 'days')
  if (weekStart.month() === weekEnd.month()) {
    return `${weekStart.format('MMM D')} - ${weekEnd.format('D, YYYY')}`
  }
  return `${weekStart.format('MMM D')} - ${weekEnd.format('MMM D, YYYY')}`
}

export function weekOffsetLabel(offset: number): string {
  if (offset === -1) return 'Last week'
  if (offset === 1) return 'Next week'
  return 'This week'
}

export function formatDayHeading(day: moment.Moment): string {
  if (day.isSame(moment(), 'day')) return `Today, ${day.format('MMMM D')}`
  return day.format('dddd, MMMM D')
}

export function formatEventDateRange(startDate: Date, endDate: Date): string {
  if (moment(startDate).isSame(moment(endDate), 'day')) {
    return moment(startDate).format('MMMM D')
  }
  const endFormat = moment(startDate).month() === moment(endDate).month() ? 'D' : 'MMM D'
  return `${moment(startDate).format('MMMM D')} - ${moment(endDate).format(endFormat)}`
}
